import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import MenuPDF from "../../images/MENUPDF.pdf"

import "./header.scss"

const Header = ({ siteTitle }) => (
  <div className="section-container header-row-container">
    <header className="site-header">
      <Link
        to="/"
        style={{
          textDecoration: `none`,
        }}
        className="logo"
      >
        <StaticImage
          src="../../images/Mole-logo.png"
          width={300}
          quality={95}
          formats={["AUTO", "WEBP", "AVIF"]}
          alt="logo"
          className=""
          placeholder="none"
        />
        <h1 style={{ display: "none" }}>{siteTitle} Restaurant </h1>
      </Link>

      {/* <button
      onClick={onHamburgerClick}
      id="navToggle"
      className="nav-toggle hamburger hamburger--collapse"
      type="button"
    >
      <span className="hamburger-box">
        <span className="hamburger-inner"></span>
      </span>
    </button> */}

      <div className="nav-wrapper">
        <nav  className="main-navigation">
          <Link to="#about" className="nav-link">
            About
          </Link>
          <a href={MenuPDF} className="nav-link">
            Menu
          </a>
          <Link to="#events" className="nav-link">
            What's On
          </Link>
          <Link to="#contact" className="nav-link">
            Contact
          </Link>
        </nav>

        <nav className="social-nav">
          <a href="https://www.facebook.com" className="social-link">
            <i className="fab fa-facebook-square"></i>
          </a>
          <a href="https://www.instagram.com" className="social-link">
            <i className="fab fa-instagram-square"></i>
          </a>
          <a href="https://www.twitter.com" className="social-link">
            <i className="fab fa-twitter-square"></i>
          </a>
        </nav>
      </div>
    </header>
  </div>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
